import styled from "styled-components";

export const KeyItem = styled.li`
  margin-bottom: ${({ theme }) => theme.space.md};
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const KeyLabel = styled.span`
  ${({ theme, keyStyle }) => {
    switch (keyStyle) {
      case "strikethrough":
        return "text-decoration: line-through;";
      case "capital-red":
        return `
            text-transform: uppercase;
            color: ${theme.colors.red.base};
        `;
      case "highlighted-key":
        return "background-color: #cde9ea;";
      default:
        return;
    }
  }}
`;

export const KeyMeaning = styled.span`
  vertical-align: top;
`;
